// extracted by mini-css-extract-plugin
export default {"language-selector":"LanguageSelector_language-selector__nuZcH","active":"LanguageSelector_active__luWeI"};